import CookieHelper from '../../common/helpers/cookieHelper'
import segmentado from './segmentado';
import cuota from './cuota';
import { UCL } from '../core/UserClientLibs'

class User {
  constructor() {
    this.UsuarioId = "";
    this.AccessToken = "";
    this.OrigenLoginTipoId = "";
    this.TipoAsociarCredencial = "";
    this.xToken = "";
    this.xValue = "";
    this.xKey = "";       // Este par�metro solo va para requests de token temporal 
    this.Retorno = "";
    this.UsuarioUsuario = "";
    this.Avatar = 0;
    this.Email = "";
    this.EmailCodificado = "";
    this.UsuarioDetalleNombre = "";
    this.UsuarioDetalleApellido = "";
    this.Clave = "";
    this.Credencial = "";
    this.Credenciales = [];
    this.tipoDocumento = "";
    this.dni = "";
    this.tipoParticipacion = "";
    this.UserAgent = "";
    this.Recaptcha = "";
    this.Codigo = "";
    this.SitioId = 1;
    this.EstadoId = "";
    this.Ip = "";
    this.Guid = "";
    this.UsuarioFacebookId = "";
    this.FbName = "";
    this.FbFirstName = "";
    this.FbLastName = "";
    this.FbGender = "";
    this.FbLocale = "";
    this.FbAgeRange = "";
    this.FbEmail = "";
    this.FbBirthday = "";
    this.FbHometown = "";
    this.FbLocation = "";
    this.UsuarioGmailId = "";
    this.GName = "";
    this.GFamilyName = "";
    this.GGivenName = "";
    this.GBirthday = "";
    this.GGender = "";
    this.GCurrentLocation = "";
    this.GMail = "";
    this.IsNewUser = false;
    this.NeedRecaptchaValidation = false;
    this.HayCookie = 0;
    this.Experiments = [];
    this.ProductosPremium = [];
    this.UsuarioDetalleClubNacion = "";
    this.Propension = "0";
    this.Segmento = "";
    this.Cuota = null;
    this.initModel();
  }

  initModel() {
    UCL.GetIdTokenValidatedAsync().then((idToken) => {
      this.xToken = idToken;
      this.UsuarioId = (CookieHelper.readCookie("usuario%5Fid") && CookieHelper.readCookie("usuario%5Fid") != null) ? CookieHelper.readCookie("usuario%5Fid") : null;
      this.UsuarioUsuario = ((idToken && idToken !== '' && CookieHelper.readCookie("usuario%5Fusuario") && CookieHelper.readCookie("usuario%5Fusuario") !== '') ? CookieHelper.readCookie("usuario%5Fusuario") : null);
      this.Email = ((idToken && idToken !== '' && CookieHelper.readCookie("usuarioemail") && CookieHelper.readCookie("usuarioemail") !== '') ? CookieHelper.readCookie("usuarioemail") : null);
      if (CookieHelper.readCookie("ProductoPremiumId") && CookieHelper.readCookie("ProductoPremiumId") !== null) {
        this.ProductosPremium = (CookieHelper.readCookie("ProductoPremiumId").split(','));
      }
      this.UsuarioDetalleClubNacion = (CookieHelper.readCookie("usuarioDetalleClubNacion") && CookieHelper.readCookie("usuarioDetalleClubNacion") != null) ? CookieHelper.readCookie("usuarioDetalleClubNacion") : null;
      this.Propension = (CookieHelper.readCookie("propension") && CookieHelper.readCookie("propension") != null) ? CookieHelper.readCookie("propension") : "0";
      this.Segmento = segmentado.getSegmento(this.Propension);
      this.Cuota = cuota.getCuota();
      console.log(this.Segmento)
    })
  }

  hasPDF() {
    return this.ProductosPremium.includes('3');
  }

  hasAccesoDigital() {
    return this.ProductosPremium.includes('2');
  }

  hasDigitalSuscription() {
    return this.ProductosPremium.length > 0
  }

  isLogged() {
    return UCL.IsUserLogInAsync()
  }

  getEmail() {
    return this.Email || this.FbEmail || this.GMail
  }
}


export default {
  createUser: () => new User()
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/models/user.js